import {createContext, useReducer} from 'react';
import PropTypes from 'prop-types';

const defaultModalState = {
  open: false,
  modalType: '',
  title: '',
  message: '',
  tableHeaders: [],
  tableData: [],
  actions: [],
  buttonText: '',
  handleClose: () => false,
  handleConfirm: () => false,
};
const ModalState = createContext(defaultModalState);
const {Provider} = ModalState;

const reducer = (state, action) => {
  switch (action.type) {
    case 'openMessage':
      return {
        ...state,
        open: true,
        modalType: 'message',
        title: action.title,
        message: action.message,
        buttonText: action.buttonText,
        handleClose: action.handleClose,
        handleConfirm: action.handleConfirm,
      }
    case 'openOptions':
      return {
        ...state,
        open: true,
        modalType: 'options',
        title: action.title,
        message: action.message,
        actions: action.actions,
      }
    case 'openTable':
      return {
        ...state,
        open: true,
        modalType: 'table',
        title: action.title,
        tableHeaders: action.tableHeaders,
        tableData: action.tableData,
        handleClose: action.handleClose,
      }
    case 'close':
      return defaultModalState;
    default:
      throw new Error('Unrecognizable modal action');
  }
};

const ModalProvider = ({children}) => {
  const [state, dispatch] = useReducer(reducer, defaultModalState);

  return (
    <Provider value={{state, dispatch}}>
      {children}
    </Provider>
  );
}

ModalProvider.propTypes = {
  children: PropTypes.node
}

export {
  ModalProvider,
  ModalState,
};
